import React, { useRef, useState, useEffect } from "react"
import "../../../node_modules/video-react/dist/video-react.css"
import * as Style from "./VideoPlayer.scss"
import ReactPlayer from "react-player"
import useVideoEnd from "../custom_hooks/use-videoend"

const VideoPlayer = props => {
  const playerRef = useRef(null)
  const [isReady, setIsReady] = useState(false)
  const [playing, setPlaying] = useState(false)
  // const [controlSpeed, setControlSpeed] = useState(1)
  // let mzminutes = Math.floor(duration / 60)
  // let mzseconds = Math.floor(duration - mzminutes * 60)

  // const videoSpeedControl = (event) => {
  //   if (event.target.dataset.type === '0.50') {
  //     setControlSpeed(0.50)
  //   }
  //   if (event.target.dataset.type === '0.75') {
  //     setControlSpeed(0.75)
  //   }
  //   if (event.target.dataset.type === '1') {
  //     setControlSpeed(1)
  //   }
  //   if (event.target.dataset.type === '1.50') {
  //     setControlSpeed(1.50)
  //   }
  //   if (event.target.dataset.type === '2') {
  //     setControlSpeed(2)
  //   }
  // }

  // useEffect(() => {
  //   let videoSpeed = playerRef.current.props.playbackRate;
  //   setControlSpeed(videoSpeed)
  // }, [])

  const { watchedVideo } = useVideoEnd(props.strapi_id)

  const playHandler = () => {
    setPlaying(true)
  }

  const getUserId = () => {
    const localUserItem = localStorage.getItem("MontesoriUser")
    if (localUserItem) {
      const user = JSON.parse(localUserItem)
      return user.user.id
    }
  }

  const handleDuration = duration => {
    const userID = getUserId()
    if (userID) {
      localStorage.setItem(
        `Video ${props.strapi_id} - User ${userID}`,
        JSON.stringify(duration.playedSeconds)
      )
    }
  }

  const timeStampHandler = event => {
    if (!isReady) {
      const userID = getUserId()
      if (userID) {
        const videoTime = localStorage.getItem(
          `Video ${props.strapi_id} - User ${userID}`
        )
        const timeStamp = JSON.parse(videoTime)
        event.seekTo(timeStamp ? timeStamp : 0)
        setIsReady(true)
      }
    }
  }

  const videoEnd = () => {
    if (playing) {
      console.log("video-end")
      watchedVideo()
      setPlaying(false)
    }
  }

  return (
    <div className={Style.playerWrapper}>
      <ReactPlayer
        className={Style.reactPlayer}
        playsInline
        url={`${props.videoPlayer.video}`}
        width="100%"
        height="100%"
        controls={true}
        title={"video"}
        onReady={timeStampHandler}
        onEnded={videoEnd}
        onProgress={handleDuration}
        onPlay={playHandler}
      />
      {/* <details className={Style.speedDropdown} >
        <summary>Current Speed: {controlSpeed}</summary>
        <button data-type={"0.50"} onClick={videoSpeedControl}>x 0.50</button>
        <button data-type={"0.75"} onClick={videoSpeedControl}>x 0.75</button>
        <button data-type={"1"} onClick={videoSpeedControl}>x 1</button>
        <button data-type={"1.50"} onClick={videoSpeedControl}>x 1.50</button>
        <button data-type={"2"} onClick={videoSpeedControl}>x 2</button>
      </details> */}
    </div>
  )
}

export default VideoPlayer
